<p-tabView (onChange)="handleChange($event)">
  <p-tabPanel [header]="tab.value" *ngFor="let tab of tabs;">
  </p-tabPanel>
</p-tabView>
